import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e25f9b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sm:mb-0 inline sm:block mr-2"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

import { generateUUID } from "@ionic/cli/lib/utils/uuid";
import {
    IonDatetime,
    IonIcon,
    IonPopover
} from "@ionic/vue";
import {
    calendarClearOutline,
    createOutline,
    timeOutline
} from "ionicons/icons";
import moment from "moment";
import { computed, PropType, ref } from "vue";
import { useI18n } from 'vue-i18n';
import MultiplePopover from "./MultiplePopover.vue";

// @ts-ignore - does not like [null, String]

export default /*#__PURE__*/_defineComponent({
  __name: 'DateChange',
  props: {
  format: {
    type: String as PropType<'icon' | 'text'>,
    required: true
  },
  modelValue: {
    type: [null, String],
    nullable: true,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false
  },
  dateIcon: {
    type: String,
    default: calendarClearOutline
  },
},
  emits: ["cancel", "changed", "update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const { locale, t } = useI18n();

const triggerDate = generateUUID();
const triggerDate2 = generateUUID();
const triggerTime = generateUUID();

const lastEmitValue = ref<string | null>(null);

const displayDate = computed(() =>
  props.modelValue ?
    props.format === "icon"
      ? moment(props.modelValue).format("DD.MM.YYYY")
      : `${new Date(props.modelValue).toLocaleDateString(locale.value)}, `
    : `${props.title}: ${t("hzba.datum.noDateSet")}`
);

const displayTime = computed(() =>
  props.modelValue ?
    props.format === "icon"
      ? moment(props.modelValue).format("HH:mm")
      : new Date(props.modelValue).toLocaleTimeString(locale.value)
    : ""
);

const changeDate = (newDate: any) => {
  if (newDate.detail.value === lastEmitValue.value) {
    // for some reason different ion-datetime components react to the same confirmation button, filter out same values for this reason
    return;
  }
  // TODO: not optimal to call emit twice, would need to refactor API call in useDateChangeUtils
  emit("update:modelValue", newDate.detail.value);
  emit("changed");
  lastEmitValue.value = newDate.detail.value;
};

const cancel = () => {
  emit("cancel");
};

const handlePropagation = (event: MouseEvent) => {
  if (!props.readonly) {
    event.stopPropagation();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      class: _normalizeClass(["mt-1 mb-0 flex items-center", __props.readonly ? '' : 'cursor-pointer']),
      onClick: handlePropagation
    }, [
      (__props.modelValue && __props.format === 'text')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.title) + ": ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        id: _unref(triggerDate),
        class: _normalizeClass(__props.format === 'icon' ? 'icon-format-styles' : 'text-format-styles')
      }, [
        (__props.format === 'icon')
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              icon: __props.dateIcon,
              class: "mr-2",
              title: __props.title
            }, null, 8, ["icon", "title"]))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(displayDate.value), 1)
      ], 10, _hoisted_2),
      _createElementVNode("span", {
        id: _unref(triggerTime),
        class: _normalizeClass(__props.format === 'icon' ? 'icon-format-styles' : 'text-format-styles')
      }, [
        (__props.modelValue && __props.format === 'icon')
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              icon: _unref(timeOutline),
              class: "ml-3 mr-1"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(displayTime.value), 1)
      ], 10, _hoisted_3),
      _createElementVNode("span", {
        id: _unref(triggerDate2),
        class: _normalizeClass(__props.format === 'icon' ? 'icon-format-styles' : 'text-format-styles')
      }, [
        (__props.modelValue && __props.format === 'icon')
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              icon: _unref(createOutline),
              class: "ml-2"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_4)
    ], 2),
    _createVNode(MultiplePopover, {
      triggers: __props.readonly ? [undefined] : [_unref(triggerDate), _unref(triggerDate2)]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonDatetime), {
          presentation: "date",
          size: "fixed",
          "done-text": _ctx.$t('hzba.buttons.select'),
          "cancel-text": _ctx.$t('hzba.buttons.abbrechen'),
          value: __props.modelValue,
          "show-default-buttons": true,
          locale: _unref(locale),
          disabled: __props.loading,
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (changeDate($event))),
          onIonCancel: cancel
        }, null, 8, ["done-text", "cancel-text", "value", "locale", "disabled"])
      ]),
      _: 1
    }, 8, ["triggers"]),
    _createVNode(_unref(IonPopover), {
      "keep-contents-mounted": true,
      trigger: __props.readonly ? undefined : _unref(triggerTime),
      "trigger-action": "click"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonDatetime), {
          presentation: "time",
          size: "fixed",
          "done-text": _ctx.$t('hzba.buttons.select'),
          "cancel-text": _ctx.$t('hzba.buttons.abbrechen'),
          value: __props.modelValue,
          "show-default-buttons": true,
          locale: _unref(locale),
          disabled: __props.loading,
          onIonChange: _cache[1] || (_cache[1] = ($event: any) => (changeDate($event))),
          onIonCancel: cancel
        }, null, 8, ["done-text", "cancel-text", "value", "locale", "disabled"])
      ]),
      _: 1
    }, 8, ["trigger"])
  ], 64))
}
}

})